import React from 'react'
import menuIcon from '../../../../assets/images/menu.png'

const HamburgerMenu = ({ onClick, variant = 'logged-in' }) => {
  const getId = () => {
    return variant === 'logged-in'
      ? 'mobile-menu-icon'
      : 'mobile-menu-icon-home'
  }

  return (
    <img
      src={menuIcon}
      id={getId()}
      className="fluid-image"
      alt="Hamburger navigation menu."
      onClick={onClick}
    />
  )
}

export default HamburgerMenu
